import type { IDrawShape } from "./IDrawShape";


export abstract class DrawShape<T> implements IDrawShape {

    TypeName!: string

    abstract get Shape(): T;
}